import init from '../initSPA';
import Guide from './app.vue';

const routes = [
  {
    path: '/',
    name: '极速支付引导页',
    component: Guide,
  },
];

init(routes);
